<p-card styleClass="flex">
    <ng-template pTemplate="header">
        <div class="p-3 flex justify-between">
            <h2 class="text-xl font-semibold">PPM Registration Stats</h2>
            <ng-container *ngIf="canEditPpmGoals()">
                <app-icon-button 
                    [icon]="icons.solid.faGear" 
                    tooltip="Update PPM Registration Goals" 
                    tooltipPosition="top"
                    (click)="updateRegistrationGoals()"
                ></app-icon-button>
            </ng-container>
        </div>
    </ng-template>
    <div class="flex flex-col md:flex-row gap-5 items-stretch">
        <div class="w-full h-full">
            <app-original-registration-stats-graph></app-original-registration-stats-graph>
        </div>
        <div class="w-full h-full">
            <app-registration-progress></app-registration-progress>
        </div>
    </div>
</p-card> 